//@flow

import React from 'react';
import { themr } from 'react-css-themr';
import { CheckboxTypes, CheckboxVersions } from './constants';
import CheckboxV1 from './versions/v1/';
import CheckboxV2 from './versions/v2/';
import MenuItemCheckboxTheme from './MenuItemCheckbox.scss';
import popOverFactory from 'common/components/core/popover/popOverFactory';

type CheckboxProps = {
    version: string
};

const CheckBoxByVersion = {
    [CheckboxVersions.v1]: CheckboxV1,
    [CheckboxVersions.v2]: CheckboxV2
};

const Checkbox = ({ version, ...rest }): CheckboxProps => {
    const CheckboxComponent = CheckBoxByVersion[version];
    return <CheckboxComponent {...rest} />;
};

Checkbox.defaultProps = {
    version: CheckboxVersions.v1
};

const MenuItemCheckbox = themr(
    'MenuItemCheckbox',
    MenuItemCheckboxTheme
)(Checkbox);

const CheckboxWithPopOver = popOverFactory({
    Component: Checkbox
});

export default Checkbox;
export {
    CheckboxTypes,
    MenuItemCheckbox,
    Checkbox,
    CheckboxVersions,
    CheckboxWithPopOver
};
